module.exports = __webpack_public_path__ + "img/260720945_3_10.8445d942.png";